<template>
  <admin-layout>
    <template slot="content">
      <h2 class="subpoenas-title mb-3">Intimações</h2>
      <subpoenas :isAdmin="true" />
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';
import Subpoenas from '@/components/tabs/Subpoenas';

export default {
  name: 'AdminSubpoenas',
  components: {
    AdminLayout,
    Subpoenas,
  },
};
</script>

<style scoped>
  .subpoenas-title {
    font-weight: 600;
  }
</style>
